import { Sparkles, ArrowRight } from 'lucide-react'

interface LandingFinalCTAProps {
  onSignIn: () => void
  onSignUp: () => void
}

export function LandingFinalCTA({ onSignIn, onSignUp }: LandingFinalCTAProps) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-brand-purple via-brand-blue to-brand-dark py-28 text-white">
      <div className="pointer-events-none absolute inset-0 opacity-30">
        <div className="absolute -top-32 -left-20 size-96 rounded-full bg-brand-pink blur-3xl" />
        <div className="absolute -bottom-32 -right-20 size-[28rem] rounded-full bg-brand-green blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-4xl px-4 text-center md:px-8">
        <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-widest text-brand-cyan backdrop-blur">
          <Sparkles className="size-4" /> Bora começar
        </div>
        <h2 className="mt-6 font-display text-4xl font-black leading-[1.05] md:text-6xl lg:text-7xl">
          Pronto para{' '}
          <span className="font-hl text-brand-magenta">protagonizar</span> sua
          jornada?
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg text-white/85">
          Crie sua conta gratuitamente e comece hoje mesmo.
        </p>

        <div className="mt-9 flex flex-wrap justify-center gap-3">
          <button
            onClick={onSignUp}
            className="inline-flex items-center gap-2 rounded-2xl bg-primary px-8 py-4 font-extrabold text-primary-foreground shadow-[0_6px_0_var(--color-primary-dark)] transition hover:-translate-y-0.5 cursor-pointer"
          >
            Criar Conta <ArrowRight className="size-5" />
          </button>
          <button
            onClick={onSignIn}
            className="inline-flex items-center gap-2 rounded-2xl border-2 border-white/30 bg-white/5 px-8 py-4 font-extrabold text-white backdrop-blur transition hover:bg-white/15 cursor-pointer"
          >
            Entrar
          </button>
        </div>

        {/* Badges decorativos */}
        <div
          className="pointer-events-none absolute left-4 top-12 -rotate-[8deg] rounded-2xl bg-brand-yellow px-4 py-2 text-brand-dark shadow-xl animate-float md:left-16"
          aria-hidden
        >
          <div className="font-hl text-sm">+500 XP</div>
        </div>
        <div
          className="pointer-events-none absolute right-4 top-24 rotate-[6deg] rounded-2xl bg-brand-green px-4 py-2 text-brand-dark shadow-xl animate-float md:right-20"
          style={{ animationDelay: '1s' }}
          aria-hidden
        >
          <div className="font-hl text-sm">Nova Jornada</div>
        </div>
        <div
          className="pointer-events-none absolute bottom-10 left-10 -rotate-3 rounded-2xl bg-brand-pink px-4 py-2 text-white shadow-xl animate-float"
          style={{ animationDelay: '1.6s' }}
          aria-hidden
        >
          <div className="font-hl text-sm">Recompensa Desbloqueada</div>
        </div>
      </div>
    </section>
  )
}
